import React from "react";
import { Box, Typography } from "@mui/material";

const StatusLegend = () => {
  const legendData = [
    { label: "Not attempted", type: "filled", color: "#8898AA" }, // gray
    { label: "Answered", type: "filled", color: "#C3DDFD" }, // light blue
    {
      label: "Flagged",
      type: "outlined",
      borderColor: "#FFA500",
      backgroundColor: "#ffffff",
    }, // orange border, white background
  ];

  return (
    <Box display="flex" gap={2} sx={{ padding: "10px 0px" }}>
      {legendData.map((item) => (
        <Box key={item.label} display="flex" alignItems="center" gap={1}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor:
                item.type === "filled" ? item.color : item.backgroundColor,
              border:
                item.type === "outlined"
                  ? `2px solid ${item.borderColor}`
                  : "none",
            }}
          />
          <Typography
            variant="body2"
            color="textSecondary"
            sx={{ fontSize: "13px" }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default StatusLegend;
